import IAction from "../../models/IAction";
import BaseReducer from "../../utilities/BaseReducer";
import DocumentsAction from "./DocumentsAction";
import DocumentsActionModel from "./models/DocumentActionModel";
import DocumentsDownloadActionModel from "./models/DocumentsDownloadActionModel";
import DocumentsInfoModel from "./models/DocumentsInfoModel";
import DocumentsSignStatusModel from "./models/DocumentsSignStatusModel";
import IDocumentsState from "./models/IDocumentsState";
import InfoDocumentsModel from "./models/InfoDocumentsModel";

export default class DocumentsReducer extends BaseReducer<IDocumentsState> {
    public readonly initialState: IDocumentsState = {
        documentsInfo: new DocumentsInfoModel({
            infoDocumentsToBeUploaded: [
                {
                    fileId: "",
                    fileName: "",
                    printDossierCode: 0,
                    printCode: 0,
                    documentName: "Cedolino",
                    documentCode: "",
                    documentDescription: "Cedolino",
                    documentType: 1,
                },
            ] as InfoDocumentsModel[],
        }),
        uploadDocument: new DocumentsActionModel({}),
        deleteDocument: new InfoDocumentsModel({}),
        generateDocument: new DocumentsActionModel({}),
        downloadDocument: new DocumentsDownloadActionModel({}),
        // aviaFirmaDigitale: new DocumentsSignStatusModel({}),
        // checkSignStatus: new DocumentsSignStatusModel({}),
        statusSign: new DocumentsSignStatusModel({}),
    };

    public [DocumentsAction.REQUEST_DOCUMENTI_INFO_GET_FINISHED](
        state: IDocumentsState,
        action: IAction<DocumentsInfoModel>
    ): IDocumentsState {
        //Get the first element of the array (cedolino)
        let firstElement = state.documentsInfo.infoDocumentsToBeUploaded[0];
        let infoDocumentsToBeUploaded = action.payload?.infoDocumentsToBeUploaded;
        //Check if cedolino was uploaded for all tipoRichiesta
        const cedolino = infoDocumentsToBeUploaded?.find(
            (item) => item.documentCode === "222" || item.documentCode === "254" || item.documentCode === "280"
        );
        //If cedolino was uploaded, set it as the first element of the array and remove it from the response list
        if (cedolino?.documentCode) {
            firstElement = new InfoDocumentsModel({
                ...cedolino,
                documentDescription: "Cedolino",
            });
            infoDocumentsToBeUploaded = action.payload?.infoDocumentsToBeUploaded?.filter(
                (item) => item.documentCode !== "222" && item.documentCode !== "254" && item.documentCode !== "280"
            );
        }
        infoDocumentsToBeUploaded = [firstElement, ...infoDocumentsToBeUploaded!];
        infoDocumentsToBeUploaded?.sort((a, b) => a.documentDescription.localeCompare(b.documentDescription));
        return {
            ...state,
            documentsInfo: {
                idEstimateRequest: action.payload?.idEstimateRequest!,
                idRequestType: action.payload?.idRequestType!,
                idMacroProduct: action.payload?.idMacroProduct!,
                idAdministrativeCategory: action.payload?.idAdministrativeCategory!,
                infoDocumentsToBeSigned: action.payload?.infoDocumentsToBeSigned!,
                infoDocumentsToBeUploaded: infoDocumentsToBeUploaded,
                idEstimate: action.payload?.idEstimate,
            } as DocumentsInfoModel,
        };
    }

    public [DocumentsAction.REQUEST_DOCUMENT_UPLOAD_FINISHED](
        state: IDocumentsState,
        action: IAction<DocumentsActionModel>
    ): IDocumentsState {
        return {
            ...state,
            uploadDocument: action.payload!,
        };
    }

    public [DocumentsAction.REQUEST_DOCUMENT_GENERATE_FINISHED](
        state: IDocumentsState,
        action: IAction<DocumentsActionModel>
    ): IDocumentsState {
        return {
            ...state,
            generateDocument: action.payload!,
        };
    }

    public [DocumentsAction.REQUEST_SIGN_FINISHED](
        state: IDocumentsState,
        action: IAction<DocumentsSignStatusModel>
    ): IDocumentsState {
        return {
            ...state,
            statusSign: action.payload!,
        };
    }

    public [DocumentsAction.REQUEST_SIGN_STATUS_FINISHED](
        state: IDocumentsState,
        action: IAction<DocumentsSignStatusModel>
    ): IDocumentsState {
        return {
            ...state,
            statusSign: action.payload!,
        };
    }

    public [DocumentsAction.REQUEST_SIGN_CANCEL_FINISHED](
        state: IDocumentsState,
        action: IAction<DocumentsSignStatusModel>
    ): IDocumentsState {
        return {
            ...state,
            statusSign: action.payload!,
        };
    }

    public [DocumentsAction.RESET_DOCUMENTS](state: IDocumentsState, action: IAction<void>): IDocumentsState {
        return {
            ...state,
            documentsInfo: this.initialState.documentsInfo,
        };
    }

    public [DocumentsAction.REQUEST_DOCUMENT_DELETE_FINISHED](
        state: IDocumentsState,
        action: IAction<InfoDocumentsModel>
    ): IDocumentsState {
        const documentsToUpload = state.documentsInfo.infoDocumentsToBeUploaded;
        const newDocumentsToUpload = documentsToUpload.map((item: InfoDocumentsModel) => {
            if (item.documentCode === action.payload?.documentCode) {
                return {
                    ...action.payload,
                    fileId: "",
                    fileName: "",
                    documentDescription: action.payload.documentDescription,
                };
            } else {
                return item;
            }
        });
        const documentsToSign = state.documentsInfo.infoDocumentsToBeSigned;
        const newDocumentsToSign = documentsToSign.map((item: InfoDocumentsModel) => {
            if (item.documentCode === action.payload?.documentCode) {
                return {
                    ...action.payload,
                    fileId: "",
                    fileName: "",
                    documentDescription: action.payload.documentDescription,
                };
            } else {
                return item;
            }
        });

        return {
            ...state,
            documentsInfo: {
                ...state.documentsInfo,
                infoDocumentsToBeUploaded: newDocumentsToUpload,
                infoDocumentsToBeSigned: newDocumentsToSign,
            } as DocumentsInfoModel,
            deleteDocument: action.payload!,
        };
    }
}
